import { render, staticRenderFns } from "./AdminBaseSettings.vue?vue&type=template&id=1f6be774&scoped=true"
import script from "./AdminBaseSettings.vue?vue&type=script&lang=js"
export * from "./AdminBaseSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminBaseSettings.vue?vue&type=style&index=0&id=1f6be774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6be774",
  null
  
)

export default component.exports